import React, { useEffect, useState } from "react";
import "../styles/StaticPages.css";

const FAQ_DATA = [
  {
    question: "How do I place an order?",
    answer:
      "Browse products, add your preferred items to the cart, proceed to checkout, enter your delivery details, and complete payment using the available payment methods.",
  },
  {
    question: "Do I need an account to order?",
    answer:
      "You may be able to browse products without an account, but creating an account helps you track orders, manage your wishlist, and access a smoother checkout experience.",
  },
  {
    question: "How can I track my order?",
    answer:
      "Once your order is confirmed, you can view its status from your account order section. Updates may include order confirmation, processing, shipped, and delivered.",
  },
  {
    question: "What payment methods are available?",
    answer:
      "Easy World supports available online payment methods integrated into the platform. The exact options may vary depending on your location and current payment setup.",
  },
  {
    question: "Can I cancel my order?",
    answer:
      "Orders may be cancelled before they are processed or shipped. Once processing has started, cancellation may not always be possible.",
  },
  {
    question: "Do you offer returns or refunds?",
    answer:
      "Yes, eligible products may be returned or refunded according to our return policy. Conditions may vary depending on product type and return reason.",
  },
  {
    question: "How do I contact customer support?",
    answer:
      "You can contact us through the Contact Us page for assistance related to orders, returns, account issues, or general inquiries.",
  },
  {
    question: "How do I share the app with others?",
    answer:
      "Use the Share App option in the footer. On supported devices it opens native sharing, and on others it copies the website link to your clipboard.",
  },
];

export default function Faq() {
  const [openIndex, setOpenIndex] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="sp-root">
      <div className="sp-container">
        <div className="sp-header">
          <div className="sp-chip">Help Center</div>
          <h1 className="sp-title">Frequently Asked Questions</h1>
          <p className="sp-sub">
            Find answers to common questions about ordering, payments, delivery,
            returns, and customer support.
          </p>
        </div>

        <div className="sp-faq-list">
          {FAQ_DATA.map((item, index) => {
            const isOpen = openIndex === index;

            return (
              <div className="sp-faq-item" key={index}>
                <button
                  type="button"
                  className="sp-faq-question"
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                >
                  <span className="sp-faq-question-text">{item.question}</span>
                  <span className="sp-faq-icon">{isOpen ? "−" : "+"}</span>
                </button>

                {isOpen && (
                  <div className="sp-faq-answer">
                    {item.answer}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}